/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Component, useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import SelectCheckBox from './SelectCheckbox';
import Column from './Column';
import Select from '../Select';
import Dropdown from '../Dropdown';
import OData from '../Utils/odata';
import Table from '../Table';
import Checkbox from '../Checkbox';
import Spinner from '../Spinner';
import Filter from '../Filter';
import { QueryOptions, resolveFilter } from '../Utils/QueryOptions';
import SortLeftIcon from '../Icons/SortLeftIcon';
import SortRightIcon from '../Icons/SortRightIcon';
import SkipToStartIcon from '../Icons/SkipToStartIcon';
import SkipToEndIcon from '../Icons/SkipToEndIcon';
import DownIcon from '../Icons/DownIcon';
import ODataTableContext from './ODataTableContext';
import Log from '../../utils/log';
import { deprecatedUsage } from '../Utils/devUtils';
import ODataTableStorage from './ODataTableStorage';
import { groupBy } from '../Utils/ODataLoader';
import { loadDataSource, existFixedColumns } from '../Utils/table';

const TablePagination = (props) => {
  const {
    abilitataPrecedente, onClickToStart, onClickToPrec,
    abilitataSuccessiva, onClickToEnd, onClickToSucc,
    currentPage, currentPageRef, onChangeCurrentPage,
    totalPages, totalItems,
    pageSize, onChangePageSize, availablePageSizes,
  } = props;
  return (
    <span className="table__pagination">
      <span
        className="table__arrow"
        disabled={abilitataPrecedente}
        onClick={onClickToStart}
        role="presentation"
      >
        <SkipToStartIcon />
      </span>
      <span
        className="table__arrow"
        disabled={abilitataPrecedente}
        onClick={onClickToPrec}
        role="presentation"
      >
        <SortLeftIcon />
      </span>
      <span className="table__currentPage">
        <input
          defaultValue={(currentPage + 1)}
          onChange={onChangeCurrentPage}
          ref={currentPageRef}
        />
        {' di '}
        {totalPages}
      </span>
      <span
        className="table__arrow"
        disabled={abilitataSuccessiva}
        onClick={onClickToSucc}
        role="presentation"
      >
        <SortRightIcon />
      </span>
      <span
        className="table__arrow"
        disabled={abilitataPrecedente}
        onClick={onClickToEnd}
        role="presentation"
      >
        <SkipToEndIcon />
      </span>
      <span className="table__records">
        Totale:
        <strong>{totalItems}</strong>
      </span>
      <span className="table__results">Risultati per pagina: </span>
      <Select
        className="table__paginationSelector"
        onChange={onChangePageSize}
        value={pageSize}
      >
        {availablePageSizes.map((x, i) => (
          <Select.Option
            key={i} // eslint-disable-line react/no-array-index-key
            value={x}
          >
            {x}
          </Select.Option>
        ))}
      </Select>
    </span>
  );
};

TablePagination.propTypes = {
  /**
   * Abilitazione bottoni prec.
   */
  abilitataPrecedente: PropTypes.bool,
  /**
   * Callback attivata al click di "vai allo start".
   */
  onClickToStart: PropTypes.func,
  /**
   * Callback attivata al click di "vai al precendete".
   */
  onClickToPrec: PropTypes.func,
  /**
 * Abilitazione bottoni succ.
 */
  abilitataSuccessiva: PropTypes.bool,
  /**
   * Callback attivata al click di "vai allo start".
   */
  onClickToEnd: PropTypes.func,
  /**
   * Callback attivata al click di "vai al precendete".
   */
  onClickToSucc: PropTypes.func,
  /**
   * Numero pagina corrente.
   */
  currentPage: PropTypes.number,
  /**
   * Numero pagina corrente.
   */
  totalPages: PropTypes.number,
  /**
   * Ref function dell'input di modifica pagina corrente.
   */
  currentPageRef: PropTypes.func,
  /**
   * Callback attivata al click di "vai al precendete".
   */
  onChangeCurrentPage: PropTypes.func,
  /**
   * Numero totale di oggetti.
   */
  totalItems: PropTypes.number,
  /**
   * Dimensione di una pagina.
   */
  pageSize: PropTypes.number,
  /**
   * Callback attivata alla modifica della dimensione della pagina.
   */
  onChangePageSize: PropTypes.func,
  /**
     * Lista di dimensioni pagine
     */
  availablePageSizes: PropTypes.arrayOf(PropTypes.number),
};

TablePagination.defaultProps = {
  abilitataPrecedente: true,
  onClickToStart: null,
  onClickToPrec: null,
  abilitataSuccessiva: true,
  onClickToEnd: null,
  onClickToSucc: null,
  currentPage: 0,
  totalPages: 1,
  currentPageRef: undefined,
  onChangeCurrentPage: null,
  totalItems: 0,
  pageSize: 5,
  onChangePageSize: null,
  availablePageSizes: [10, 20, 50],
};

/**
 * Gestisce un pulsante toggle per visualizza/nascodenre i filtri
 */
const ToggleFiltriAvanzati = (props) => {
  const { showFilters, onClick } = props;
  return (
    <span
      className="table__filterToggle"
      onClick={onClick}
      role="presentation"
    >
      {showFilters ? <DownIcon /> : <SortRightIcon />}
      {' Filtri avanzati'}
    </span>
  );
};

ToggleFiltriAvanzati.propTypes = {
  /**
   * Indica se il filtro è visibile
   */
  showFilters: PropTypes.bool,
  /**
   * Callback attivata al click dell'azione. L'unico paramatro è l'azione stessa.
   */
  onClick: PropTypes.func,
};

ToggleFiltriAvanzati.defaultProps = {
  showFilters: false,
  onClick: null,
};

/**
 * ODataTable GroupActions
 */
const GroupActions = (props) => {
  const { groupActions, onClick } = props;
  return (
    <div className="table__groupActions">
      <Dropdown
        className="table__groupActionsSelector"
        title="Azioni di gruppo"
      >
        {groupActions.map((x) => (
          <Dropdown.Item
            key={x}
            onClick={() => { onClick(x); }}
          >
            {x}
          </Dropdown.Item>
        ))}
      </Dropdown>
    </div>
  );
};

GroupActions.propTypes = {
  /**
   * Elenco delle azioni applicabili agli elementi selezionati
   * della tabella
   */
  groupActions: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback attivata al click dell'azione. L'unico paramatro è l'azione stessa.
   */
  onClick: PropTypes.func,
};

GroupActions.defaultProps = {
  groupActions: null,
  onClick: null,
};

/**
 * Tabella della ODataTable.
 * TODO sposare all'interno la gestione della selezione degli items.
 */
const DataTable = (props) => {
  const {
    className,
    selectable, selected, onSelectedAll, onSelected,
    columnHeaders, items, row, additionalRowData,
  } = props;
  const fixed = useMemo(() => existFixedColumns(columnHeaders, Column), [columnHeaders]);
  const Row = row;
  return (
    <Table
      className={className}
      fixedLayout={fixed}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <Table.Head>
        <tr>
          {selectable && (
            <th className="tableHeader__checkbox">
              <Checkbox
                checked={selected}
                className="table__checkbox"
                onClick={onSelectedAll}
              />
            </th>
          )}
          {columnHeaders}
        </tr>
      </Table.Head>
      <Table.Body>
        {items.map((x, i) => (
          <Row
            additionalRowData={additionalRowData}
            item={x}
            itemIndex={i}
            key={i} // eslint-disable-line react/no-array-index-key
            onSelected={onSelected}
          />
        ))}
      </Table.Body>
    </Table>
  );
};

DataTable.propTypes = {
  /**
     * Classi css aggiuntive
     */
  className: PropTypes.string,
  /**
     * Indica se gli elementi della tabella sono selezionabili
     */
  selectable: PropTypes.bool,
  /**
     * Indica se tutti gli elementi sono selezionati
     */
  selected: PropTypes.bool,
  /**
   * callback invocata alla selezione di tutti gli elementi
  */
  onSelectedAll: PropTypes.func,
  /**
   * callback invocata alla selezione di un elemento
  */
  onSelected: PropTypes.func,
  /**
     * Contenuto da renderizzare
     */
  columnHeaders: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * Array degli elementi da visualizzare.
   */
  items: PropTypes.array,
  /**
     * Componente da renderizzare come riga della tabella
     */
  row: PropTypes.elementType,
  /**
     * Informazioni aggiuntive iniettate nel componente Row
     */
  additionalRowData: PropTypes.object,
};

DataTable.defaultProps = {
  className: undefined,
  selectable: false,
  selected: false,
  columnHeaders: undefined,
  row: undefined,
  items: [],
  additionalRowData: undefined,

  onSelectedAll: undefined,
  onSelected: undefined,
};

/**
Il componente `ODataTable` è stato pensato per permettere agevolmente di disegnare una griglia paginata collegata ad un endpoint `OData`,
semplificandone al massimo l'utilizzo ma permettendo comunque un grado di flessibilità sufficiente.

Nella sua versione più semplice la `ODataTable` ci permette di disegnare una tabella specificando solamente:

- L'endpoint `OData` a cui collegarsi tramite la proprietà url
- Le colonne da disegnare specificando le `ODataTable.Columns` presenti
- Come disegnare ogni riga specificando un componente per il rendering di una riga (nel nostro caso `ExampleRow`)

Le funzionalità offerte da questo componente sono:

- Ordinamento delle righe de/crescente cliccando sull'intestazione della colonna desiderata
- Paginazione automatica
- Possibilità per l'utente di modificare la dimensione della pagina
- Possibilità di mostrate i filtri per le colonne prescelte tramite la proprietà filter applicabile all'oggetto `ODataTable.Column`.
Tramite questa prop è possibile specificare: type: tipo del campo di input

Per gestire le colonne di una tabella il componente `ODataTable` mette a disposizione il sotto-componente `ODataTable.Columns`
che permettono di specificare l'intestazione della colonna e opzionalmente,
la proprietà su cui eseguire l'ordinamento mediante il parametro propertyName.
Il componente `ODataTable` permette anche di avere delle checkbox per la selezione delle singole righe o
di tutte le righe semplicemente specificando la proprietà selectable e inserendo in ogni riga una `ODataTable.SelectCheckBoxAggiungendo`
alle colonne la prop filter è possibile aggiungere dei filtri per i campi desiderati; per informazioni sulle Props ammesse,
riferirsi alla documentazione del componente Filter.Per aggiungere un filtro su una proprietà non presente nella tabella è possibile specificare,
tramite la prop additionalFilters, i campi aggiuntivi su cui effettuare il filtraggio.

Spesso `ODataTable` è utilizzata con il componente `Filter` (vedi documentazione).

__Attenzione:__ Dalla versione del Framework 3.1 viene utilizzato lo standard OData 4 e non più lo standard OData 2.
Vedere le linee guida del componente `Filter` per i dettagli.

 */
class ODataTable extends Component {
  static Column = Column;

  static SelectCheckBox = SelectCheckBox;

  static FilterTypes = Filter.FilterTypes;

  static QueryOptions = QueryOptions;

  static resolveFilters(filter) {
    const filtri = [];
    Object.keys(filter).forEach((x) => {
      const filtriProp = filter[x];
      const group = groupBy(filtriProp, 'query');
      Object.keys(group).forEach((z) => {
        const query = resolveFilter(x, group[z]);
        filtri.push(query);
      });
    });
    return filtri;
  }

  constructor(props, context) {
    super(props, context);

    this.odata = props.odata || OData;

    let dati = null;
    if (props.store) {
      dati = new ODataTableStorage(props.store).caricaStato();
      if (dati != null) dati.filtri = this.mergeFilters(dati.filtri);
    }
    this.firstRender = true;
    const sortOrderP = props.sortOrder !== false;
    this.state = {
      loading: false,
      selected: false,
      items: [],
      count: 0,
      currentPage: dati != null ? dati.currentPage : 0,
      pageSize: dati != null ? dati.pageSize : props.pageSize || 20,
      availablePageSizes: props.availablePageSizes,
      totalPages: 0,
      sortProperty: dati != null ? dati.sortProperty : props.sortProperty,
      sortOrder: dati != null ? dati.sortOrder : sortOrderP,
      filter: dati != null ? dati.filtri : {},
      showFilters: props.showFilters,
    };
  }

  UNSAFE_componentWillReceiveProps({ url, store }) {
    const { url: urlP, store: storeP } = this.props;
    if (urlP !== url || storeP !== store) {
      this.reinizializza({ url, store });
    }
  }

  reinizializza = ({ url, store }) => {
    const dati = store ? new ODataTableStorage(store).caricaStato() : null;
    const filter = dati != null ? this.mergeFilters(dati.filtri) : {};
    this.refFilter.reinitializeFilter(filter);
    this.setState({
      currentPage: 0,
      filter,
    }, this.loadPage);
  };

  ordina = (proprieta, ordine) => {
    this.setState({
      sortProperty: proprieta,
      sortOrder: ordine,
    }, this.loadPage);
  };

  /**
   * @public
   * Ritorna l'url della tabella.
   * @returns {string} url
   */
  // eslint-disable-next-line react/no-unused-class-component-methods
  urlCorrente = () => {
    const { url } = this.props;
    const {
      filter, pageSize, currentPage, sortProperty, sortOrder,
    } = this.state;
    const filtri = ODataTable.resolveFilters(filter);

    return this.odata.generaUrl(
      url,
      pageSize,
      currentPage * pageSize,
      sortProperty,
      sortOrder,
      filtri,
    );
  };

  loadPage = () => {
    this.setState({
      loading: true,
      selected: false,
    });
    const {
      currentPage, filter, pageSize, sortProperty,
      sortOrder,
    } = this.state;
    const filtri = ODataTable.resolveFilters(filter);
    this.refInput.value = currentPage + 1;

    const { store } = this.props;
    if (store) {
      new ODataTableStorage(store).salvaStato({
        pageSize,
        currentPage,
        sortProperty,
        sortOrder,
        filtri: filter,
      });
    }
    const { url } = this.props;
    if (url && typeof (url) === 'string') {
      this.odata.cerca(
        url,
        pageSize,
        currentPage * pageSize,
        sortProperty,
        sortOrder,
        filtri,
      ).then((results) => {
        this.setResults(results, pageSize, filtri, currentPage, sortProperty, sortOrder);
      });
    }
    const { dataSource } = this.props;
    loadDataSource(
      dataSource,
      (result, props) => this.setResults(result, props.pageSize, props.filtri, props.currentPage, props.sortProperty, props.sortOrder),
      {
        pageSize, currentPage, sortProperty, sortOrder, filtri,
      },
    );
  };

  setResults = (results, pageSize, filtri, currentPage, sortProperty, sortOrder) => {
    this.setState({
      loading: false,
      items: results ? results.Items : [],
      totalPages: results ? Math.ceil(results.Count / pageSize) : 0,
      count: results ? results.Count : 0,
    }, this.notificaSelezionati);
    const { onPageLoad } = this.props;
    if (onPageLoad) {
      onPageLoad(
        results.Items,
        results.Count,
        filtri,
        currentPage,
        sortProperty,
        sortOrder,
      );
    }
    // se arrivo in una pagina con zero elementi che non è
    // la prima ma ci sarebbero altre pagine torna in prima pagina
    if (results && results.Items && results.Items.length === 0
      && Math.ceil(results.Count / pageSize) > 0 && currentPage > 0) {
      this.setState({
        currentPage: 0,
      }, this.loadPage);
    }
  };

  iniziale = () => {
    this.setState({
      currentPage: 0,
    }, this.loadPage);
  };

  precedente = () => {
    const { currentPage } = this.state;
    if (currentPage === 0) {
      return;
    }
    this.setState((prevState) => ({
      currentPage: prevState.currentPage - 1,
    }), this.loadPage);
  };

  prossima = () => {
    const { currentPage, totalPages } = this.state;
    if (currentPage === totalPages - 1 || totalPages === 0) {
      return;
    }
    this.setState((prevState) => ({
      currentPage: prevState.currentPage + 1,
    }), this.loadPage);
  };

  ultima = () => {
    const { currentPage, totalPages } = this.state;
    if (currentPage === totalPages - 1 || totalPages === 0) {
      return;
    }
    this.setState((prevState) => ({
      currentPage: prevState.totalPages - 1,
    }), this.loadPage);
  };

  modificaPageSize = (event, value) => {
    this.setState({
      pageSize: value,
      currentPage: 0,
    }, this.loadPage);
  };

  seleziona = () => {
    const { selected, items } = this.state;
    const nuovo = !selected;
    const newItems = items.map((item) => ({ ...item, Selected: nuovo }));
    this.setState({
      selected: nuovo,
      items: newItems,
    }, () => this.notificaSelezionati() && this.forceUpdate());
  };

  selezionatoSingolo = (indice) => {
    const { items } = this.state;
    const newItems = [...items];
    newItems[indice].Selected = !newItems[indice].Selected;
    this.setState((prevState) => ({
      items: newItems,
      selected: prevState.items.every((x) => x.Selected),
    }), this.notificaSelezionati);
  };

  notificaSelezionati = () => {
    const { onSelezionati } = this.props;
    onSelezionati && onSelezionati(this.selezionati());
  };

  selezionati = () => {
    const { items } = this.state;
    return items.filter((x) => x.Selected);
  };

  /**
   * @public
   */
  // eslint-disable-next-line react/no-unused-class-component-methods
  pulisciSelezione = () => {
    const { items } = this.state;
    const newItems = items.map((item) => ({ ...item, Selected: false }));
    this.setState({ items: newItems, selected: false });
  };

  hasChildrenWithFilters = () => {
    const { additionalFilters, children } = this.props;
    return (children && React.Children.toArray(children)
      .filter((x) => x && x.props.filter != null).length > 0) || additionalFilters;
  };

  toggleFilters = () => {
    this.setState((prevState) => ({ showFilters: !prevState.showFilters }));
  };

  populateFilters = () => {
    const { additionalFilters, children, useAdvancedFilters } = this.props;
    deprecatedUsage(
      this,
      !useAdvancedFilters,
      'framework-ui-components',
      'ODataTable.useAdvancedFilters',
      'ODataTable: You have to use useAdvancedFilters=true. The current behavior will be removed in the future release.',
    );

    const filters = [];
    React.Children
      .map(children, (x, i) => {
        if (x && x.type._componentType === 'Column' && x.props.filter != null) { // eslint-disable-line no-underscore-dangle
          filters.push({
            propertyName: x.props.propertyName || x.props.filter.propertyName,
            description: x.props.filter.description || x.props.propertyName,
            type: x.props.filter.type,
            query: x.props.filter.query,
            component: x.props.filter.component,
            options: x.props.filter.options,
            autoFocus: x.props.filter.autoFocus,
            range: x.props.filter.range,
            url: x.props.filter.url,
            renderProperty: x.props.filter.renderProperty,
            width: x.props.filter.width,
            right: x.props.filter.right,
            customFilter: x.props.filter.customFilter,
            showInOthers: useAdvancedFilters && x.props.filter.showInOthers,
          });
        }
      });

    if (additionalFilters) {
      additionalFilters
        .forEach((x) => {
          filters.push({
            propertyName: x.propertyName,
            description: x.description || x.propertyName,
            type: x.type,
            query: x.query,
            component: x.component,
            options: x.options,
            autoFocus: x.autoFocus,
            range: x.range,
            url: x.url,
            renderProperty: x.renderProperty,
            width: x.width,
            right: x.right,
            customFilter: x.customFilter,
            showInOthers: useAdvancedFilters && x.showInOthers,
          });
        });
    }

    return filters;
  };

  /**
   * @public
   */
  // eslint-disable-next-line react/no-unused-class-component-methods
  clearFilters = () => {
    this.refFilter && this.refFilter.cleanAll();
  };

  notifica = (value) => {
    const { onGroupAction, url } = this.props;
    const {
      filter, items, sortProperty, sortOrder,
    } = this.state;
    if (onGroupAction) {
      const selected = items.filter((x) => x.Selected);
      if (selected.length > 0) {
        let generatedUrl = null;
        if (selected.length === items.length) {
          const filtri = [];
          Object.keys(filter).forEach((x) => {
            const query = resolveFilter(x, filter[x]);
            filtri.push(query);
          });
          generatedUrl = this.odata.generaUrl(
            url,
            null,
            null,
            sortProperty,
            sortOrder,
            filtri,
          );
        }
        onGroupAction(value, selected, generatedUrl);
      }
    }
  };

  setCurrentPage = (evt) => {
    const { value } = evt.target;
    const { totalPages, currentPage } = this.state;
    if (value === '') {
      this.refInput.value = '';
    } else if (value === '0') {
      this.setState({ currentPage: 0 }, this.loadPage);
    } else if (value > 0 && value <= totalPages) {
      this.setState({ currentPage: value - 1 }, this.loadPage);
    } else {
      this.refInput.value = currentPage + 1;
    }
  };

  onFiltersReloaded = (f, reload) => {
    this.setState((prevState) => ({
      filter: f,
      currentPage: reload ? prevState.currentPage : 0,
    }), () => {
      this.refInput.value = 1;
      this.loadPage();
    });
  };

  mergeFilters(filtri) {
    let definitionFilter = null;
    const filterStored = {};
    Object.keys(filtri).forEach((x) => {
      const filtriProp = filtri[x];
      filterStored[x] = filtriProp.map((f) => {
        if (f.query === QueryOptions.CUSTOM_FILTER) {
          if (!definitionFilter) {
            definitionFilter = this.populateFilters();
          }
          const defFilters = definitionFilter.filter((df) => df.propertyName === f.name
            && df.query === QueryOptions.CUSTOM_FILTER);
          let defFilter;
          if (defFilters.length !== 1) {
            Log.error('Filtro custom non univocamente identificabile');
            defFilter = null;
          } else {
            [defFilter] = defFilters;
          }
          return {
            ...f,
            customFilter: defFilter ? defFilter.customFilter : null,
          };
        }
        return f;
      });
    });
    return filterStored;
  }

  render() {
    const {
      loading, currentPage, totalPages, filter,
      sortProperty, sortOrder, count, pageSize,
      availablePageSizes, showFilters, selected,
      items,
    } = this.state;
    const {
      className, row, initialFilters, store,
      groupActions, selectable, children, emptyMessage,
      additionalRowData, useAdvancedFilters,
    } = this.props;
    const tableClasses = cns(
      {
        'table--loading': loading,
      },
      className,
    );
    const abilitataPrecedente = parseInt(currentPage, 10) === 0;
    const abilitataSuccessiva = parseInt(currentPage, 10) === (parseInt(totalPages, 10) - 1);
    const hasFilters = this.hasChildrenWithFilters();
    let filters = [];
    if (hasFilters) {
      filters = this.populateFilters();
    }
    const filtriApplicati = Object.keys(filter).length !== 0;
    let filtriIniziali = initialFilters || [];

    if (this.firstRender && store && !initialFilters) {
      this.firstRender = false;
      const dati = new ODataTableStorage(store).caricaStato();
      if (dati != null) {
        filtriIniziali = [];
        Object.keys(dati.filtri).forEach((x) => {
          filtriIniziali = filtriIniziali.concat(dati.filtri[x]);
        });
        filtriIniziali.map((filtroIniziale) => {
          const newFiltroIniziale = filtroIniziale;
          // imposto anche sui filtri iniziali il custom filter (se necessario)
          if (newFiltroIniziale.query === QueryOptions.CUSTOM_FILTER && filters) {
            const defFilters = filters.filter((df) => df.propertyName === newFiltroIniziale.name
              && df.query === QueryOptions.CUSTOM_FILTER);
            let defFilter;
            if (defFilters.length !== 1) {
              Log.error('Filtro custom non univocamente identificabile');
              defFilter = null;
            } else {
              [defFilter] = defFilters;
            }
            newFiltroIniziale.customFilter = defFilter ? defFilter.customFilter : undefined;
          }
          newFiltroIniziale.propertyName = newFiltroIniziale.name;
          newFiltroIniziale.value = newFiltroIniziale.valore;
          return newFiltroIniziale;
        });
      }
    }

    const containerClasses = cns('table__container', { 'table__container--advanced_filters': useAdvancedFilters });

    return (
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      <ODataTableContext.Provider value={{
        sortProperty,
        sortDirection: sortOrder,
        sortCallback: this.ordina,
      }}
      >
        <div className={containerClasses}>
          {groupActions && [
            <GroupActions groupActions={groupActions} onClick={this.notifica} />,
            <hr />,
          ]}
          {
            !useAdvancedFilters
            && hasFilters
            && <ToggleFiltriAvanzati showFilters={showFilters} onClick={this.toggleFilters} />
          }
          <TablePagination
            abilitataPrecedente={abilitataPrecedente}
            onClickToStart={this.iniziale}
            onClickToPrec={this.precedente}
            abilitataSuccessiva={abilitataSuccessiva}
            onClickToEnd={this.ultima}
            onClickToSucc={this.prossima}
            currentPage={currentPage}
            currentPageRef={(r) => { this.refInput = r; }}
            onChangeCurrentPage={this.setCurrentPage}
            totalPages={totalPages}
            totalItems={count}
            pageSize={pageSize}
            onChangePageSize={this.modificaPageSize}
            availablePageSizes={availablePageSizes}
          />
          <div className="table__filterSeparator" />
          <Filter
            filterCallback={this.onFiltersReloaded}
            filtriRicerca={filters}
            initialFilters={filtriIniziali}
            ref={(r) => { this.refFilter = r; }}
            show={hasFilters && (showFilters || useAdvancedFilters)}
            otherFiltersLabel={useAdvancedFilters ? 'Filtri Avanzati' : undefined}
          />
          {!useAdvancedFilters && <hr />}
          <DataTable
            className={tableClasses}
            selectable={selectable}
            selected={selected}
            onSelectedAll={this.seleziona}
            onSelected={this.selezionatoSingolo}
            columnHeaders={children}
            items={items}
            additionalRowData={additionalRowData}
            row={row}
            {...this.props}
          />
          {loading && (
            <div className="table__loader">
              <Spinner large />
            </div>
          )}
          {filtriApplicati && !loading && items.length === 0
            && <div className="table__noFilteredElements">Nessun elemento trovato per i filtri di ricerca impostati</div>}
          {!filtriApplicati && !loading && items.length === 0 && emptyMessage
            && <div className="table__noElements">{emptyMessage}</div>}
        </div>
      </ODataTableContext.Provider>
    );
  }
}

ODataTable.defaultProps = {
  additionalFilters: undefined,
  additionalRowData: null,
  availablePageSizes: [10, 20, 50],
  children: null,
  className: null,
  dataSource: null,
  emptyMessage: null,
  groupActions: null,
  initialFilters: null,
  onGroupAction: null,
  onPageLoad: null,
  onSelezionati: null,
  pageSize: 20,
  row: null,
  selectable: false,
  showFilters: false,
  sortOrder: true,
  sortProperty: null,
  store: null,
  url: null,
  odata: undefined,
};

ODataTable.propTypes = {
  /**
Definisce dei filtri aggiuntivi. Per maggiori dettagli consultare la scheda del componente `Filter`.
   */
  additionalFilters: PropTypes.arrayOf(PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
    description: PropTypes.string,
    type: PropTypes.string,
    query: PropTypes.number,
    component: PropTypes.number,
    options: PropTypes.array,
    autoFocus: PropTypes.bool,
    range: PropTypes.object,
    url: PropTypes.string,
    renderProperty: PropTypes.string,
    width: PropTypes.string,
    customFilter: PropTypes.func,
    showInOthers: PropTypes.bool,
  })),
  /**
Informazioni aggiuntive iniettate nel componente Row
  */
  additionalRowData: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
Lista di dimensioni pagine
  */
  availablePageSizes: PropTypes.arrayOf(PropTypes.number),
  /**
Contenuto da renderizzare (vedi `Column`)
  */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
Classi css aggiuntive
  */
  className: PropTypes.string,
  /**
Definisce gli elementi da renderizzare senza effettuare chiamate a API:```
 dataSource(pageSize, skip, sortProperty, sortOrder, filtri)
```
dove:

- `pageSize`: dimensione della pagina
- `skip`: currentPage * pageSize
- `sortProperty`: proprietà di ordinamento
- `sortOrder`: tipologia di ordinamento (true = ordinamento crescente)
- `filtri`: eventuali filtri da applicare
   */
  dataSource: PropTypes.func,
  /**
Messaggio da visualizzare in assenza di risultati
  */
  emptyMessage: PropTypes.node,
  /**
Elenco delle azioni applicabili agli elementi selezionati della tabella
   */
  groupActions: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
Definisce dei filtri iniziali preimpostati
  */
  initialFilters: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
Callback invocata alla selezione di una azione di gruppo:

```
 onGroupAction(value, selected, generatedUrl)
```
dove:

- `value`: valore dell'azione selezionata
- `selected`: items selezionati su cui applicare l'azione
- `generatedUrl`: url generata con la configurazione attuale della tabella
                  (nel caso di selezione di tutti gli elementi)
   */
  onGroupAction: PropTypes.func,
  /**
Callback invocata ad ogni caricamento di pagina:

```
 onPageLoad(pageItems, totalCount, currentFilter, currentPage, sortProperty, sortOrder)
```
dove:

- `pageItems`: elementi della pagina
- `totalCount`: numero totale di elementi
- `currentFilter`: filtri usati per la chiamata corrente
- `currentPage`: numero della pagina corrente
- `sortProperty`: proprietà usata per l'ordinamento
- `sortOrder`: true = ordinamento crescente
   */
  onPageLoad: PropTypes.func,
  /**
Callback invocata alla selezione di almeno una riga

```
 onSelezionati(items)
```
dove:

- `items`: array con gli items selezionati
   */
  onSelezionati: PropTypes.func,
  /**
Dimensione iniziare di una pagina di risultati
  */
  pageSize: PropTypes.number,
  /**
Componente da renderizzare come riga della tabella
  */
  row: PropTypes.func,
  /**
Indica se gli elementi della tabella sono selezionabili
  */
  selectable: PropTypes.bool,
  /**
Indica se mostrare i filtri aperti o collassati
  */
  showFilters: PropTypes.bool,
  /**
Indica se invertire l'ordinamento
  */
  sortOrder: PropTypes.bool,
  /**
Nome del campo su cui effettuare l'ordinamento di default
  */
  sortProperty: PropTypes.string,
  /**
Nome dell'oggetto salvato nello storage del browser.
In questo modo quando viene ricaricata la apgina verranno riapplicati gli eventuali filtri
che erano stati impostati e verrà posizionata la tabella alla pagina che era stata visitata
  */
  store: PropTypes.string,
  /**
Url da chiamare per ottenere i risultati
  */
  url: PropTypes.string,

  /**
Customize l'OData provider. Vedi `Components/Utils/odata`.
   */
  odata: PropTypes.shape({
    generaUrl: PropTypes.func.isRequired,
    cerca: PropTypes.func.isRequired,
  }),
  /**
Usa gestione filtri avanzati.
Questa gestione prevede che di default i filtri vengano sempre visualizzati,
ma alcuni vengano presentati in una sezione (Filtri avanzati appunto)
che l'utente può visualizzare o nascondere agento su un pulsante toggle.

Per specificare che un filtro deve stare nella sezione "Filtri avanzati",
impostare la proprietà `showInOthers`.
  */
  useAdvancedFilters: PropTypes.bool,
};

ODataTable.defaultProps = {
  availablePageSizes: [10, 20, 50],
  useAdvancedFilters: false,
};

export default ODataTable;
